import styled from 'styled-components';

import { OnboardingStyle } from '../../../public/onboarding/onboarding-style';
import { theme } from '../../../../global-styles/colors';

export const SuccessUbicationStyle = styled.div`
  ${OnboardingStyle} {
    min-height: calc(100vh - 180px);
  }

  .success-img {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    img {
      height: 200px;
      width: 100%;
    }
  }

  .container-image {
    margin: 30px;
  }

  .success-text {
    span,
    a {
      color: ${theme.primary.primary50};
    }

    a {
      display: block;
    }

    p {
      text-align: center;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`;
